import { createErrorWrapper } from '../utils';

export const LOADING_ERROR = 'LOCATION.LOADING_ERROR';

export const loadingErr = createErrorWrapper(LOADING_ERROR, 'Failed to load locations');
